// extracted by mini-css-extract-plugin
export default {"label":"FormLabel_label__XeqHa"};